import { render, staticRenderFns } from "./PrebidPartnersTable.vue?vue&type=template&id=0578b268&"
import script from "./PrebidPartnersTable.vue?vue&type=script&lang=js&"
export * from "./PrebidPartnersTable.vue?vue&type=script&lang=js&"
import style0 from "./PrebidPartnersTable.vue?vue&type=style&index=0&id=0578b268&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports